module.exports = __webpack_public_path__ + "static/media/deficiente-marker.de257791.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/deficiente-marker.svg
// module id = 872
// module chunks = 0